import { loc } from "../../../../core/utils"
import AutoCompleteSelect from "../../../../form/AutoCompleteSelect"
import NumberField from "../../../../form/NumberField"
import Select from "../../../../form/Select"
import TextField from "../../../../form/TextField"
import "./product-line.scss"
import React from "react"
import { Col, Row } from "react-bootstrap"

function ProductLine({
  apiUrl,
  token,
  tunnelData,
  setProduct,
  shopValues,
  name,
  index,
  isMultiProduct,
  deleteButton,
  addProductModal
}) {
  return (
    <div className="product-line">
      <Row className="align-items-end">
        <Col xs={12} sm={12} md={6} lg={12} xl={6}>
          <Select
            name={`${name}.family`}
            label={loc("simulation_family_input_label")}
            url={
              shopValues.shop &&
              `${apiUrl}middle-business-service/api/v1/categories/by-supplierid/${shopValues.shop.value.split("-")[0]}`
            }
            token={token}
            disabled={!shopValues.shop}
            extract={(items) =>
              items
                .map((item) => {
                  return {
                    value: item.parent.parentCategoryId,
                    label: item.parent.labelCategoryParent
                  }
                })
                .filter((element, index, self) => self.findIndex((e) => element.value === e.value) === index)
            }
            oneElement={true}
          />
        </Col>

        <Col xs={12} sm={12} md={6} lg={12} xl={6}>
          <Select
            name={`${name}.category`}
            label={loc("simulation_category_input_label")}
            clearIfNotExists={false}
            url={
              shopValues.shop &&
              shopValues?.products[index]?.family?.value &&
              `${apiUrl}middle-business-service/api/v1/categories/by-category/${
                shopValues.shop.value.split("-")[0]
              }?parentCategoryId=${shopValues?.products?.[index]?.family.value}`
            }
            token={token}
            disabled={!shopValues?.products?.[index]?.family}
            extract={(items) => {
              return items
                .map((item) => {
                  return { value: item.parent.id, label: item.parent.label }
                })
                .filter((element, index, self) => self.findIndex((e) => element.value === e.value) === index)
            }}
            oneElement={true}
          />
        </Col>

        <Col xs={12} sm={12} md={6} lg={12} xl={6}>
          <div className="product-div">
            <AutoCompleteSelect
              namePrefix={name}
              name={`${name}.sku`}
              label={loc("simulation_product_input_label")}
              disabled={!shopValues.shop}
              url={`${tunnelData.apiUrl}middle-business-service/api/v1/products/autocomplete-reference/criteria`}
              token={token}
              supplierId={shopValues?.shop?.value?.split("-")[0]}
              minLength={3}
              post
              extractList={(list) => {
                return list?.map((e) => {
                  const skuAndDesignation = e.skuDistributor + " - " + e.designation
                  return { value: e, label: skuAndDesignation }
                })
              }}
              className="full-width"
              setProduct={setProduct}
            />
            {shopValues?.productCreationEnabled && addProductModal}
          </div>
        </Col>

        <Col xs={12} sm={6} md={6} lg={6} xl={3}>
          <NumberField
            name={`${name}.price`}
            label={loc("simulation_price_input_label")}
            disabled={shopValues?.allowModifyProductPrice === false}
          />
        </Col>

        <Col xs={12} sm={6} md={6} lg={6} xl={3}>
          <NumberField
            name={`${name}.quantity`}
            label={loc("simulation_quantity_input_label")}
            disabled={!isMultiProduct}
          />
        </Col>

        <Col xs={12} sm={12} md={6} lg={12} xl={6}>
          <TextField
            name={`${name}.brand`}
            label={loc("simulation_brand_input_label")}
            hidden={!shopValues?.products?.[index]?.sku}
            disabled={true}
          />
        </Col>

        <Col xs={12} sm={12} md={12} lg={12} xl={6}>
          <TextField
            name={`${name}.description`}
            label={loc("simulation_description_input_label")}
            hidden={!shopValues?.products?.[index]?.sku}
            disabled={true}
          />
        </Col>
      </Row>
      <section className="d-flex justify-content-end">{deleteButton}</section>
    </div>
  )
}

export default ProductLine
